module.exports = __webpack_public_path__ + "static/img/zy4.dd14aac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/index/zy4.jpg
// module id = 3Dx/
// module chunks = 0